import React from 'react';
import { connect } from "react-redux";
import '../../../styles/elements/screens/finance.scss';
import TranslationService from "../../../app/services/TranslationService";
import {Button} from "../../icymat-design/Button";


class EventDialogClass extends React.Component {
    renderEventDate = (event) => {
        let eventDate = new Date(event.time * 1000);
        let month= eventDate.getMonth() + 1;

        return (
            <tr>
                <td><strong>{TranslationService.trans(this.props.language, 'common.date')}</strong></td>
                <td>
                    {TranslationService.trans(this.props.language, 'common.date_format', {'d': eventDate.getDate(), 'm': (month < 10 ? '0' + month : month), 'Y': eventDate.getFullYear()})}
                </td>
            </tr>
        );
    }

    renderEventTime = (event) => {
        let eventStartTime = new Date(event.time * 1000);
        let eventStartHours = eventStartTime.getHours() < 10 ? '0' + eventStartTime.getHours() : eventStartTime.getHours();
        let eventStartMinutes = eventStartTime.getMinutes() < 10 ? '0' + eventStartTime.getMinutes() : eventStartTime.getMinutes();
        let eventStart12Hours = TranslationService.get12HoursHour(eventStartTime);
        let eventStart12AMPM = TranslationService.trans(this.props.language, 'common.symbols.time.' + TranslationService.get12HoursAMPM(eventStartTime))

        let eventStopTime = new Date((event.time + event.length * 60) * 1000);
        let eventStopHours = eventStopTime.getHours() < 10 ? '0' + eventStopTime.getHours() : eventStopTime.getHours();
        let eventStopMinutes = eventStopTime.getMinutes() < 10 ? '0' + eventStopTime.getMinutes() : eventStopTime.getMinutes();
        let eventStop12Hours = TranslationService.get12HoursHour(eventStopTime);
        let eventStop12AMPM = TranslationService.trans(this.props.language, 'common.symbols.time.' + TranslationService.get12HoursAMPM(eventStopTime))

        return (
            <tr>
                <td><strong>{TranslationService.trans(this.props.language, 'common.time')}</strong></td>
                <td>
                    {TranslationService.trans(this.props.language, 'common.time_format', {'H': eventStartHours, 'h': eventStart12Hours,'i': eventStartMinutes, 'a': eventStart12AMPM})} - {TranslationService.trans(this.props.language, 'common.time_format', {'H': eventStopHours, 'h': eventStop12Hours,'i': eventStopMinutes, 'a': eventStop12AMPM})}
                </td>
            </tr>
        );
    }

    /**
     * @returns {JSX.Element}
     */
    render() {
        return (
            <dialog className={"imd-dialog imd-bg-blur-black" + (this.props.event !== null ? ' imd-opened' : '')}>
                <div className="imd-dialog-body imd-bg-20-default imd-text-accent">
                    <header className="imd-text-contrast">
                        {this.props.event !== null ? this.props.event.description : ''}
                        <span className="imd-icon imd-icon-xmark imd-dialog-close" onClick={() => this.props.close()} />
                    </header>

                    <div className="imd-dialog-content">
                        <table className="imd-table imd-table-bordered imd-border-color-accent">
                            <tbody>
                                {
                                    this.props.event !== null ?
                                        this.renderEventDate(this.props.event) : null
                                }

                                {
                                    this.props.event !== null && this.props.event.length < 1440 ?
                                        this.renderEventTime(this.props.event) : null
                                }

                                <tr>
                                    <td style={{width: '30%'}}><strong>{TranslationService.trans(this.props.language, 'calendars.event.place')}</strong></td>
                                    <td>{this.props.event !== null ? this.props.event.place : ''}</td>
                                </tr>

                                <tr>
                                    <td><strong>{TranslationService.trans(this.props.language, 'calendars.event.participants')}</strong></td>
                                    <td>{this.props.event !== null ? this.props.event.participants : ''}</td>
                                </tr>

                                <tr>
                                    <td><strong>{TranslationService.trans(this.props.language, 'calendars.event.details')}</strong></td>
                                    <td>{this.props.event !== null ? this.props.event.details : ''}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <footer>
                        <Button
                            color={'accent'}
                            secondary={true}
                            text={TranslationService.trans(this.props.language, 'common.close')}
                            onClick={() => this.props.close()}
                        />
                    </footer>
                </div>
            </dialog>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        language: TranslationService.getLanguage(state.user)
    }
};

export const DetailsDialog = connect(mapStateToProps, {})(EventDialogClass);
